import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

export function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return `${n.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₽`;
}

export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('ru-RU');
}

export function BalanceBanner({ data }) {
  if (!data) return null;
  if (data.status === 'debt') {
    return (
      <div className="billing-banner billing-banner--debt">
        <strong>Долг: {formatMoney(data.debt)}</strong>
        <span className="text-secondary">Отрицательный баланс — это долг, не «минус предоплата».</span>
      </div>
    );
  }
  if (data.status === 'prepaid') {
    return (
      <div className="billing-banner billing-banner--prepaid">
        <strong>Предоплата: {formatMoney(data.prepaid)}</strong>
      </div>
    );
  }
  return (
    <div className="billing-banner">
      <strong>Баланс: 0 ₽</strong>
      <span className="text-secondary">Нет предоплаты и нет долга.</span>
    </div>
  );
}

export function TransactionsTable({ items }) {
  if (!items?.length) {
    return <p className="text-secondary">Пока нет операций.</p>;
  }
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Дата</th>
          <th>Тип</th>
          <th>Сумма</th>
          <th>Комментарий</th>
        </tr>
      </thead>
      <tbody>
        {items.map((tx) => (
          <tr key={tx.id}>
            <td>{formatDateTime(tx.created_at)}</td>
            <td>{tx.type_label || tx.type}</td>
            <td className={Number(tx.amount) < 0 ? 'text-error' : 'text-success'}>
              {formatMoney(tx.amount)}
            </td>
            <td>{tx.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
